import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageview } from '../ym'

/**
 * SPA route tracker для Яндекс.Метрики.
 * Дедуп по последнему url спасает от double-hit в StrictMode.
 */
export function YmRouteTracker() {
  const location = useLocation()
  const lastRef = useRef<string | null>(null)

  useEffect(() => {
    const url = location.pathname + location.search
    if (lastRef.current === url) return
    lastRef.current = url
    trackPageview(url, document.title)
  }, [location.pathname, location.search])

  return null
}
